/*
 * Copyright (c) 2024. Haodong JU
 */

import hillo from 'hillo'
import { getUserAndStoreRelationByDeviceId } from '@/model/dataLayer/api/SaaS/subscriptionService'

export async function getActiveCodes (deviceId) {
  // try {
  //   return (await docContentOf(doc(FireBaseStore, 'saas-active-products', deviceId))).codes
  // } catch (e) {
  //   return []
  // }
  try {
    const userStoreInfo = await getUserAndStoreRelationByDeviceId(parseFloat(deviceId))
    if (userStoreInfo && userStoreInfo.admin) {
      return [
        'base',
        'saleAnalysis',
        'queneNumber',
        'takeawayWeb',
        'extraStore',
        'advanceSales',
        'hotpotSystem',
        'scanToOrder',
        'staffManagement',
        'cashbook',
        'sales',
        'inventory',
        'restaurant',
        'kitchenMonitor',
        'reservation'
      ]
    } else {
      return await hillo.get('https://cloud-v2.aaden.io/subscriptions/activeProductCodes/' + deviceId)
    }
  } catch (e) {
    return []
  }
}
